import { IGetChecklistEntregaByIdUseCase } from "../../../presentation/useCases/read/get_checklist_entrega_by_id_use_case";
import { ChecklistEntrega } from "../../models/checklist_entrega";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetChecklistEntregaByIdUseCase
 */

export class GetChecklistEntregaByIdUseCase implements IGetChecklistEntregaByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idChecklistEntrega: number): Promise<ChecklistEntrega> {
    return await this.repository.getChecklistEntregaById(idChecklistEntrega);
  }
}
